import React from "react";


export default function Spinner(){
    return(
        <div className="spinner">
            <img src="typing.gif" alt="typing animation" ></img>
        </div>
    );
}